<template>
  <router-view/>
</template>

<script>
import 'line-awesome/dist/line-awesome/css/line-awesome.min.css'
import store from "@/store";
import {isEnvDevelopment} from "@/lib/isEnvDevelopment";

console.debug("Frontend ENV:", process.env.NODE_ENV);

if (isEnvDevelopment() === true) {
  const accountInfo = {
    "name": "Борис Щец",
    "type": "dealer",
    "role": 2,
    "dealerUniqueId": 123,
    "email": "Almira.Khisamutdinova@lukoil.com",
  };

  const accountInfoSubDiv = {
    "name": "Борис Щец>",
    "type": "StructuralSubdivisionUser",
    "role": 5,
    "dealerUniqueId": 123,
    "email": "Almira.Khisamutdinova@lukoil.com",
  };

  const brandInfo = {
    "brand": 3,
    "currentBrand": 3,
  };

  // Токен дилера
  const token = "exZ9biyUIKSDfrwHwP8hw8jb8l2e_i8m";

  // Токен сотрудника
  // const token = "Ja5k7qHtQK4_4OFNDfSUkHAGlp19Osv0";

  store.commit('account/SET_ACCOUNT', {...accountInfo, token: token});
  store.commit('account/SET_BRAND', {...brandInfo});
}

export default {}
</script>

<style lang="sass">
@import './assets/sass/styles.sass'
</style>

<style lang="css" >
@import "./assets/css/bootstrap.min.css";
@import "./assets/fonts/futuris/styles.css";
@import "./assets/fonts/futurisc/styles.css";
@import "./assets/css/styles.css";
@import "./assets/css/reset.css";
</style>
